import { PageContainer } from 'components/styles_components/container';

const MainContainer = ({ children }) => {
  return (
    <PageContainer maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
      {children}
    </PageContainer>
  );
};

export default MainContainer;
